import { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  CircularProgress,
} from "@mui/material";
import PageLayout from "../components/Common/PageLayout";
import PageBanner from "../components/Common/PageBanner";
import { getPrivacyPolicyContent } from "../actions/pagecontent.actions";

/**
 * Privacy Policy page component
 * @returns {JSX.Element}
 * @component
 */
const PrivacyPolicy = () => {
  const [apiData, setApiData] = useState(null);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    /** Async fetch */
    const _fetchPageData = async () => {
      try {
        setLoader(true);
        const data = await getPrivacyPolicyContent(true);
        setApiData(data);
      } catch (error) {
        log.error("Error fetching privacy policy content:", error);
      } finally {
        setLoader(false);
      }
    };

    _fetchPageData();
  }, []);

  return (
    <PageLayout pageName="Privacy Policy" showLoader={loader} checkComingSoon>
      {/* Banner */}
      {apiData ? (
        <PageBanner
          bannerImage={apiData?.banner_image_display}
          mainTitle={apiData?.banner_title || "Privacy Policy"}
          pageTitle="Privacy Policy"
        />
      ) : (
        <PageBanner mainTitle="Privacy Policy" pageTitle="Privacy Policy" />
      )}

      {/* Content Section */}
      <Box component="section" sx={{ py: 4 }}>
        <Container maxWidth="lg">
          <Paper elevation={1} sx={{ p: 4, borderRadius: 2 }}>
            {loader ? (
              <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
                <CircularProgress />
              </Box>
            ) : apiData ? (
              <Box
                dangerouslySetInnerHTML={{ __html: apiData?.policy }}
                sx={{
                  "& h1, & h2, & h3, & h4, & h5, & h6": {
                    mb: 2,
                    mt: 3,
                    fontWeight: 500,
                  },
                  "& p": {
                    mb: 2,
                    lineHeight: 1.7,
                  },
                  "& ul, & ol": {
                    mb: 2,
                    pl: 3,
                  },
                  "& li": {
                    mb: 1,
                  },
                }}
              />
            ) : (
              <Typography variant="body1" color="text.secondary">
                No content available
              </Typography>
            )}
          </Paper>
        </Container>
      </Box>
    </PageLayout>
  );
};

export default PrivacyPolicy;
